define('catalogTemplatesCreateView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'template!catalogTemplatesCreateTpl',
  'dynamicTextView',
  'selectView'
], function (
  Module,
  Marionette,
  _,
  Backbone,
  App,
  Tpl,
  DynamicTextView,
  SelectView
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'catalog-templates-create-view',

    regions: {
      contentRegion: '.content-region',
      typeRegion: '.type-region'
    },

    initialize: function () {
      // Prefer a model passed via options (Edit mode). Fallback to a new one (Create mode).
      if (this.options && this.options.model) {
        this.model = this.options.model;
      }
      if (!this.model) this.model = new Backbone.Model();

      // Dynamic text for content (multi-language)
      var contentModel = this.model.get('content');
      // If not already a DynamicText model, build one from existing payload
      if (!contentModel || !_.isFunction(contentModel.getTranslationCollection)) {
        // Accept both { values: {...} } and simple locale maps { en: '...', fr: '...' }
        var payload = contentModel || { values: {} };
        if (payload && !payload.values) {
          payload = { values: _.clone(payload) };
        }
        contentModel = App.request('dynamic-text:model', payload);
        this.model.set('content', contentModel);
      }
      this.contentDtModel = contentModel;
    },

    onShow: function () {
      // Content editor (multi-language)
      this.contentDtView = new DynamicTextView({
        model: this.contentDtModel,
        noSaving: true,
        hideGlossary: true,
        textAreaMode: true
      });

      this.getRegion('contentRegion').show(this.contentDtView);

      // Type select
      // SelectView expects models with an `id` (used as <option value>) and a display `value`.
      // Previously only `value` was provided, causing selection/read issues and defaulting to productPage.
      var options = new Backbone.Collection([
        { id: 'firstPage', value: 'firstPage' },
        { id: 'customerPage', value: 'customerPage' },
        { id: 'productPage', value: 'productPage' },
        { id: 'lastPage', value: 'lastPage' }
      ]);
      this.typeSelectView = new SelectView({
        collection: options,
        tabindex: 0
      });
      this.getRegion('typeRegion').show(this.typeSelectView);
      // Default selection (keep productPage as default only if no type already set)
      var initialType = this.model.get('type') || 'productPage';
      this.typeSelectView.setSelected(initialType);
      this.model.set('type', initialType);

      this.typeSelectView.on('change', _.bind(function (selectedModel) {
        // `selectedModel` is the selected option model; use its `id` as the saved value
        var selectedType = selectedModel && (selectedModel.get('id') || selectedModel.get('value'));
        if (selectedType) this.model.set('type', selectedType);
      }, this));
    }
  });
});

